module.exports = __webpack_public_path__ + "static/media/importSmall.c97a2ca9.svg";